module.exports = __webpack_public_path__ + "img/bulb.0e5c8f20.png";